/* Essential header/promo behavior only. Product enhancements load on product pages. */
(function () {
  function syncShell() {
    var promo = document.querySelector('.mp-promo');
    if (promo) {
      var height = Math.round(promo.getBoundingClientRect().height || 48);
      document.documentElement.style.setProperty('--mp-promo-h', height + 'px');
      document.body.classList.toggle('mp-promo-pad', window.innerWidth < 990);
    }

    var header = document.querySelector('.section-header');
    if (header) header.classList.add('mp-header-stable');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncShell, { once: true });
  } else {
    syncShell();
  }

  window.addEventListener('resize', syncShell, { passive: true });
})();
